/**
 * @generated SignedSource<<f33348b088e2140f90d8c07f40fc6460>>
 * @relayHash 8216059cbb21289b715613ce0d8b2e51
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3706e99a71c70f741da285a6437c04100694acb85ba97ba586fb317fc01be2ad

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type realtimeUpdater_issueCreated_Subscription$variables = {
  cloudId: string;
  projectId: string;
};
export type realtimeUpdater_issueCreated_Subscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProjectNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type realtimeUpdater_issueCreated_Subscription = {
  response: realtimeUpdater_issueCreated_Subscription$data;
  variables: realtimeUpdater_issueCreated_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueCreatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProjectNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "realtimeUpdater_issueCreated_Subscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "realtimeUpdater_issueCreated_Subscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3706e99a71c70f741da285a6437c04100694acb85ba97ba586fb317fc01be2ad",
    "metadata": {},
    "name": "realtimeUpdater_issueCreated_Subscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "17e162496dfc818aef8a5e9ba2bb211d";

export default node;
